module.exports = __webpack_public_path__ + "static/media/survey.c8a7d586.png";